import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('IS_TOOL').plugin(axiosPlugin);

let fetchStoryAction = redux.fetchActionCreate();


export const TYPES = redux.types;

export const fetchIsTool = (data) => fetchStoryAction(`/tools/istool`, data);
export const resetIsTool = () => redux.actions.reset();

export const isTool = redux.reducer();